module.exports = __webpack_public_path__ + "img/bg-purple.42e94cb2.png";